if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )

        activeMedia.loadContent();
        mediaSlider();
      }
    }
  );
}

/*
 * 商品詳細画像拡大用スライダー
 */
function mediaSlider() {
  const slideContainer = document.getElementById('product-media-slider');
  const prev = document.getElementById('product-media-prev');
  const next = document.getElementById('product-media-next');
  const slides = document.querySelectorAll('#product-media-slider > img');
  const totalSlides = slides.length;
  const slideWidth = 100 / totalSlides;
  slideContainer.style.width = `${totalSlides * 100}%`;
  slides.forEach((slide) => {
    slide.style.width = `${slideWidth}%`;
  });
  let activeCount = 0;
  let count = 0;

  function updateSlidePosition() {
    slideContainer.style.transform = `translateX(-${count * slideWidth}%)`;
  }
  function nextClick() {
    count++;
    if (count >= totalSlides) {
      count = 0;
    }
    updateSlidePosition();
  }
  function prevClick() {
    count--;
    if (count < 0) {
      count = totalSlides - 1;
    }
    updateSlidePosition();
  }

  slides.forEach((slide) => {
    if(slide.classList.contains('active')) {
      count = activeCount;
      updateSlidePosition();
    }
    activeCount++;
  });

  next.addEventListener('click', () => {
    nextClick();
  });
  prev.addEventListener('click', () => {
    prevClick();
  });
}
